import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_SAVE_COLLECTION_ITEM_BEGIN,
  COLLECTIONS_SAVE_COLLECTION_ITEM_SUCCESS,
  COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE,
  COLLECTIONS_SAVE_COLLECTION_ITEM_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function saveCollectionItem(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_SAVE_COLLECTION_ITEM_BEGIN,
    });
    const { projectId, collectionName, version, environment } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    if (environment) {
      header.headers['x-project-env'] = environment.toLowerCase();
    }
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            if (res.data.code && res.data.code !== 200) {
              const message = res.data.message;
              dispatch({
                type: COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE,
                data: { error: message },
              });
              toast.error(`Failed: ${message}`);
              reject(res.data.data);
            } else {
              dispatch({
                type: COLLECTIONS_SAVE_COLLECTION_ITEM_SUCCESS,
                data: res.data,
              });
              if (environment && header && header.headers['x-project-env']) {
                toast.success(
                  `Created Successfully in ${
                    header.headers['x-project-env'].charAt(0).toUpperCase() +
                    header.headers['x-project-env'].slice(1)
                  } !`,
                );
              } else {
                toast.success(`Created Successfully !`);
              }
              resolve(res);
            }
          } else {
            dispatch({
              type: COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveCollectionItemError() {
  return {
    type: COLLECTIONS_SAVE_COLLECTION_ITEM_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_SAVE_COLLECTION_ITEM_BEGIN:
      return {
        ...state,
        saveCollectionItemPending: true,
        saveCollectionItemError: null,
      };

    case COLLECTIONS_SAVE_COLLECTION_ITEM_SUCCESS:
      return {
        ...state,
        saveCollectionItemPending: false,
        saveCollectionItemError: null,
        saveCollectionItemPending: false,
        saveCollectionItemError: null,
        items: [action.data, ...state.items],
        selectedItem: null,
      };

    case COLLECTIONS_SAVE_COLLECTION_ITEM_FAILURE:
      return {
        ...state,
        saveCollectionItemPending: false,
        saveCollectionItemError: action.data.error,
      };

    case COLLECTIONS_SAVE_COLLECTION_ITEM_DISMISS_ERROR:
      return {
        ...state,
        saveCollectionItemError: null,
      };

    default:
      return state;
  }
}
